<template>
    <el-container>
        <td-device
            :buttons="buttons"
            :inputs="inputs"
            :addTitle="title"
            :defaultPort="defaultPort"
            :columns="columns"
            :devDisplay="devDisplay"
            :deviceLable="deviceLable"
            ref="listAdapter"
            :isOverWriteAdd="false"
            :iDeviceTypes="iDeviceTypes"
            @event="changeNode"
        ></td-device>
    </el-container>
</template>
<script>
export default {
    components: {},
    mounted() {},
    data() {
        return {
            permissionsDel: ['org:del'],
            permissionsEdit: ['org:edit'],
            permissionsCancelAllot: ['org:del'],
            iDeviceTypes: [78], // 中间件适配器
            // 所属设备是否显示
            devDisplay: false,
            inputs: [
                {
                    label: 'common.IP'
                }
            ],
            buttons: [],
            orgInfo: null,
            title: 'pgCommon.ADD_ADAPTER',
            deviceLable: 'common.SERVICE_ID',
            defaultPort: 50058,
            columns: [
                {
                    prop: 'sName',
                    label: 'common.DEVICE_NAME',
                    showOverflowTooltip: true
                },

                {
                    prop: 'sIp',
                    label: 'common.IP',
                    align: 'center'
                },

                {
                    prop: 'sOrgName',
                    label: 'common.BELONGED_DEPT',
                    showOverflowTooltip: true
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        let editBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.btnModify(params.row);
                                    }
                                }
                            },
                            this.$t('common.EDIT')
                        );
                        let deleteBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsDel, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.deleteDeviceById(params.row);
                                    }
                                }
                            },
                            this.$t('common.DELETE')
                        );
                        let cancelAllotBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsCancelAllot, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.cancelAllot(params.row);
                                    }
                                }
                            },
                            this.$t('common.CANCEL_ALLOT')
                        );
                        let buttonList = [editBtn, deleteBtn, cancelAllotBtn];
                        // if (this.$util.isEmpty(params.row.sOrgId)) {
                        //     //从第三个元素开始删除1个元素
                        //     buttonList.splice(2, 1);
                        // }
                        return createElement('div', buttonList);
                    }
                }
            ]
        };
    },
    methods: {
        // 修改
        btnModify(row) {
            this.$refs.listAdapter.btnModify(row);
        },
        // 删除
        deleteDeviceById(row) {
            this.$refs.listAdapter.deleteDeviceById(row);
        },
        // 取消分配
        cancelAllot(row) {
            this.$refs.listAdapter.cancelAllot(row);
        },
        changeNode(value) {
            this.orgInfo = value;
        }
    }
};
</script>
<style>
.inputtyle {
    margin-left: 20px;
    margin-right: 15px;
}
</style>
